angular
  .module('contributor')

  .factory('ISOCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ISOCrud extends Crud {
        constructor(list) {
          super(
            'iso' + (list || ''),
            '@@apiUrl' + '/iso17100s' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return ISOCrud;
    }
  ]);
